<template>
  <section id="gold-performance">
    <div class="intro-header">
      <div class="intro-header-name">
        <h1>Gold Spot</h1>
      </div>
      <div class="intro-subscriber">
        <!-- <flex-card
          v-if="templateShare && hasShare"
          :templateFlex="templateShare.template"
          :isPrepareCompleted="templateShare && templateShare.template ? isPrepareCompleted : false"
          @reset-fact="resetFact"
          class="share-assets"
        >
          <a slot="button" :data-action="'share_fund'" @click="generateShareTemplate">
            <i class="fas fa-share-alt"></i>
          </a>
        </flex-card> -->

        <!-- <download-assets
            v-if="this.detail && this.detail.short_code"
            class="download-assets"
            :dataType="`fund`"
            :name="this.detail.short_code"
        />-->

        <FollowingGold followingType="GoldQuote" :item="{ ID: 'gold-spot' }" />
      </div>
    </div>
    <div class="intro-nav">
      <h2 class="nav">{{ latestPrice | numberFormat}}</h2>
      <span class="percent" :class="[percentChangeColor]">{{ `(${percentChange}%)` }}</span>
      <p class="date">
        <i class="far fa-clock"></i>
        {{ `อัปเดต: ${latestDate}` }}
      </p>
    </div>
  </section>
</template>

<script>
import { timestampToDate, calPercentChange } from "../../../utils/global"
// import FlexCard from "../../../components/miniapp/share/FlexCard.vue"
import { FollowingGold } from "../../organisms/Following"

export default {
  components: {
    // FlexCard: () => import("../../../components/miniapp/share/FlexCard.vue"),
    FollowingGold
  },
  props: {
    arrData: {
      type: Array,
      default: function(){
        return []
      }
    }
  },
  data() {
    return {
      templateShare: {
        template: null
      }
    }
  },
  filters: {
    numberFormat(num) {
      var parts = num.toString().split(".")
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      return `$ ${parts.join(".")}`
    }
  },
  computed: {
    latestPrice() {
      return this.arrData && this.arrData.length ? this.arrData[this.arrData.length - 1].v : 0
    },
    latestDate() {
      return this.arrData && this.arrData.length ? timestampToDate(this.arrData[this.arrData.length - 1].t, "lll") : 0
    },
    percentChange() {
      return this.arrData && this.arrData.length
        ? calPercentChange(this.arrData[this.arrData.length - 2].v, this.arrData[this.arrData.length - 1].v, 2)
        : 0.0
    },
    percentChangeColor() {
      if (this.percentChange > 0) return "plus"
      else if (this.percentChange == 0) return "stable"
      else return "minus"
    },
    hasShare() {
      return process.env.VUE_APP_CONFIG_SHARE_LINK === "true"
    }
  },
  methods: {
    async generateShareTemplate() {
      this.isPrepareCompleted = false
      const items = this.items

      let templateStr
      if (this.type == "stock") {
        templateStr = await this.generateStockTemplate(items)
      } else if (this.type == "indice") {
        templateStr = await this.generateIndiceTemplate(items)
      }
      this.templateShare = templateStr
      this.isPrepareCompleted = true
    },
    resetFact() {
      this.isPrepareCompleted = false
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  @extend %container-style;
  position: relative;
  .intro-header {
    .intro-header-name {
      @include finCol(7, 12, 0px, top, true, true);
      h1 {
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        @extend %font-size-m;
      }
    }
    .intro-subscriber {
      @include finCol(5, 12, 0px, middle, true, true);
      text-align: right;
      user-select: none;
      .share-assets {
        margin-right: 15px;
        vertical-align: middle;
        pointer-events: auto;
        cursor: pointer;
        i {
          pointer-events: none;
          color: $color-light-grey-2;
          font-size: 22px;
        }
      }
      .following {
        color: $color-primary-finno !important;
        vertical-align: middle;
        i {
          font-size: 22px;
        }
      }
    }
  }
  .intro-nav {
    .nav {
      @extend %font-size-xl;
      display: inline-block;
    }
    .percent {
      @extend %font-size-s;
      margin-left: 5px;
      display: inline-block;
    }
    .date {
      margin-top: 0px;
      @extend %font-size-ss;
    }
  }
}
</style>